import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Loader,
} from "arv-reactcomponents";
import LoyaltyCard from "./LoyaltyCard";
import LoyaltyMoreInfoModal from "./LoyaltyMoreInfoModal";
import { MYACCOUNTPAGE } from "npmlinks-constants";

const { LOYALTY: { NO_LOYALTY_MSG } = {} } = MYACCOUNTPAGE;

@inject("LoyaltyStore")
@observer
class MyAccountLoyalty extends Component {
  constructor() {
    super();
    this.state = {
      isMoreInfoModalOpen: false,
      isMoreInfoLoading: false,
    };
    this.openMoreInfoModal = this.openMoreInfoModal.bind(this);
    this.closeMoreInfoModal = this.closeMoreInfoModal.bind(this);
  }

  openMoreInfoModal = brand => {
    this.setState({ isStoreModalOpen: true, isMoreInfoLoading: true });
    this.props.LoyaltyStore.getLoyaltyMoreInfo(brand)
      .then(() => {
        this.setState({ isMoreInfoLoading: false });
      })
      .catch(() => {
        this.setState({ isMoreInfoLoading: false });
      });
  };

  closeMoreInfoModal = () => {
    this.setState({ isStoreModalOpen: false, isMoreInfoLoading: false });
  };

  get loyaltyMoreInfoData() {
    const { loyaltyMoreInfoData } = this.props.LoyaltyStore;
    return loyaltyMoreInfoData || [];
  }

  get loader() {
    return <Loader className="nw-accountaddresslist-loader" />;
  }

  get loyaltyCards() {
    const { loyaltyCards = [] } = this.props.LoyaltyStore;
    return (
      <GridRow>
        {loyaltyCards.map(data => (
          <LoyaltyCard.component
            data={data}
            openMoreInfoModal={this.openMoreInfoModal}
          />
        ))}
      </GridRow>
    );
  }

  get noLoyaltyCards() {
    return <div>{NO_LOYALTY_MSG}</div>;
  }

  render() {
    const { isStoreModalOpen, isMoreInfoLoading } = this.state;
    const {
      LoyaltyStore: { loyaltyCards = [] },
      loader,
    } = this.props;
    return (
      <div>
        <GridContainer className="nw-myaccountloyalty-container">
          <GridRow>
            <GridColumn>
              {loader && this.loader}
              {!loader && loyaltyCards.length ? this.loyaltyCards : null}
              {!loader && !loyaltyCards.length ? this.noLoyaltyCards : null}
            </GridColumn>
          </GridRow>
        </GridContainer>
        <LoyaltyMoreInfoModal.component
          data={this.loyaltyMoreInfoData}
          isOpen={isStoreModalOpen}
          onClose={this.closeMoreInfoModal}
          loading={isMoreInfoLoading}
        />
      </div>
    );
  }
}

MyAccountLoyalty.wrappedComponent.propTypes = {
  LoyaltyStore: PropTypes.shape({
    loyaltyCards: PropTypes.arrayOf(PropTypes.object).isRequired,
    getLoyaltyMoreInfo: PropTypes.func.isRequired,
  }).isRequired,
  loader: PropTypes.bool.isRequired,
};

const getFinalComponent = component =>
  inject("LoyaltyStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: MyAccountLoyalty.wrappedComponent,
  component: MyAccountLoyalty,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/MyAccountLoyalty/index.js